import { useState } from 'react';
import { AxiosPrivate } from '../utils/axios';

import { ResponseException } from '../models';
import { ReviewDocument } from '../models/ReviewDocumentType';

export const useAddReviewDocument = () => {
  const [isFetching, setFetching] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const postDocument = async (document: ReviewDocument) => {
    try {
      setFetching(true);

      const { data } = await AxiosPrivate.post('/reviews/document', document);

      return data;
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    errors,
    postDocument,
  };
};
